import { Util } from "./util";
import { DomHelper } from "./domHelper";
import { API_URL, DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from "./appCardDefault";
function appVoucherHandleSubmit(parentNode, event, username, bearerToken, wlanList, idString) {
    if (DEBUG)
        console.log("-->appVoucherHandleSubmit", wlanList);
    event.preventDefault();
    let unifiid = document.getElementById('rudi-wlan-bereich').value;
    if (DEBUG)
        console.log("-->appVoucherHandleSubmit -> unifiid", unifiid);
    const selectedRadio = document.querySelector('input[name="printorshow"]:checked');
    const printOrShow = selectedRadio ? selectedRadio.value : '';
    let wlan = wlanList.find(element => element.unifiid === unifiid);
    let voucherOrder = {
        "unifiid": wlan.unifiid,
        "amount": Number(document.getElementById('rudi-wlan-anzahl').value),
        "duration": Util.getDurationFromInput(Number(document.getElementById('rudi-wlan-dauer').value)),
        "username": username,
        "host": wlan.host
    };
    DomHelper.appendSpinner(parentNode);
    if (printOrShow == "print")
        putVoucher(voucherOrder, bearerToken, function (response) {
            const appNode = DomHelper.getFirstParentWithClass(parentNode, 'rudi-app');
            closeVoucherApp(idString, appNode);
            DomHelper.removeCloseSection(appNode);
            appVoucherResultNewWindow(username, bearerToken, response, idString);
        });
    else
        putVoucher(voucherOrder, bearerToken, function (response) {
            appVoucherResultCurrentElement(parentNode, username, bearerToken, response, wlanList, idString);
        });
}
export function appVoucher(username, bearerToken, parentNode, app, userResponse, networkRestriction) {
    if (DEBUG)
        console.log("-->appVoucherRender");
    const idString = 'rudi-voucher';
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    const cardNode = getAppCardNode(parentNode, app, userResponse.username, userResponse.odDeskPreferences, bearerToken, networkRestriction, [], null, (event) => {
        if (DEBUG)
            console.log("Voucher handle Click");
        let injectNode = cardNode.querySelector(`.rudi-app-inject`);
        handleClickOpen(injectNode, event, username, bearerToken, userResponse.odDeskPreferences, idString);
    });
}
function closeVoucherApp(idString, appNode) {
    const parentNode = document.getElementById(idString);
    if (parentNode) {
        parentNode.innerHTML = "";
    }
    appNode.classList.remove('app-open');
    appNode.classList.add('rudi-max-height');
}
function handleClickOpen(injectNode, event, username, bearerToken, userPreferences, idString) {
    let appNode;
    if (!injectNode) {
        injectNode = document.getElementById(idString);
    }
    else {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", idString);
    }
    try {
        appNode = DomHelper.getFirstParentWithClass(injectNode, 'rudi-app');
    }
    catch (e) {
        appNode = event.target;
    }
    if (appNode) {
        if (appNode.classList.contains("app-open")) {
            if (DEBUG)
                console.log("RespApp do nothing");
        }
        else {
            appNode.classList.add('app-open');
            appNode.classList.remove('rudi-max-height');
            DomHelper.appendSpinner(injectNode);
            getUserVoucherInfo(username, bearerToken, function (response) {
                let wlanList;
                if (response != null) {
                    wlanList = JSON.parse(response.target.response);
                }
                DomHelper.removeSpinner(injectNode);
                appVoucherPartRender(injectNode, username, bearerToken, wlanList, idString);
                DomHelper.appendCloseSection(appNode, (event) => {
                    closeVoucherApp(idString, appNode);
                });
            });
        }
    }
}
function appVoucherPartRender(parentNode, username, bearerToken, wlanList, idString) {
    if (DEBUG)
        console.log("Render Voucher Part", wlanList);
    const formNode = DomHelper.appendNode(parentNode, 'form', [], [], '', 'rudi-wlan-form');
    DomHelper.appendNode(formNode, 'label', ['form-label', 'mb-0', 'mt-0'], [{ attr: 'for', value: 'rudi-wlan-anzahl' }], 'Anzahl (1-28)');
    DomHelper.appendNode(formNode, 'input', ['form-control'], [
        { attr: 'type', value: 'number' },
        { attr: 'name', value: 'anzahl' },
        { attr: 'min', value: '1' },
        { attr: 'max', value: '28' },
        { attr: 'value', value: '1' }
    ], '', 'rudi-wlan-anzahl');
    const selectOptions = [];
    for (let wlanbereich of wlanList) {
        selectOptions.push({ label: wlanbereich.name.replace("WLAN ", ""), value: wlanbereich.unifiid });
    }
    DomHelper.appendSelect(formNode, 'rudi-wlan', [], 'bereich', 'Wählen Sie einen WLAN-Bereich', selectOptions, "");
    DomHelper.appendNode(formNode, 'label', ['form-label', 'mb-0', 'mt-2'], [{ attr: 'for', value: 'rudi-wlan-dauer' }], 'Gültigkeit (5 Min - 12 Mon)');
    const durationNode = DomHelper.appendNode(formNode, 'input', ['form-range'], [
        { attr: 'type', value: 'range' },
        { attr: 'min', value: '1' },
        { attr: 'name', value: 'dauer' },
        { attr: 'max', value: '74' },
        { attr: 'value', value: '11' },
        { attr: 'list', value: 'druationmarkers' }
    ], '', 'rudi-wlan-dauer');
    DomHelper.appendNode(formNode, 'div', [], [], '1 Stunde', 'rudi-wlan-dauer-anzeige');
    durationNode.addEventListener("input", updateAppVoucherDuration);
    DomHelper.appendFormCheckbox(formNode, 'rudi-wlan-ausgabe-show', 'printorshow', 'Codes anzeigen', 'show', true);
    DomHelper.appendFormCheckbox(formNode, 'rudi-wlan-ausgabe-print', 'printorshow', 'Codes drucken', 'print', false);
    const submitRow = DomHelper.appendNode(formNode, 'div', ['rudi-submit-row'], []);
    const btnNode = DomHelper.appendNode(submitRow, 'button', ['btn', 'btn-primary', 'mt-2'], [{ attr: 'type', value: 'submit' }]);
    DomHelper.appendNode(btnNode, 'i', ['fa-light', 'fa-arrow-down', 'me-1']);
    DomHelper.appendNode(btnNode, 'span', [], [], 'Voucher bestellen');
    formNode.addEventListener("submit", function (event) {
        appVoucherHandleSubmit(parentNode, event, username, bearerToken, wlanList, idString);
    });
}
function updateAppVoucherDuration(event) {
    if (DEBUG)
        console.log("-->updateAppVoucherDuration");
    let input = document.getElementById("rudi-wlan-dauer");
    let output = document.getElementById("rudi-wlan-dauer-anzeige");
    let duration = Number(input.value);
    let durationString = "";
    if (DEBUG)
        console.log("-->updateAppVoucherDuration Value", duration);
    if (duration < 11) {
        if (DEBUG)
            console.log("-->Minuten", duration);
        durationString = `${duration * 5} Minuten`;
    }
    else if (duration <= 33) {
        if (DEBUG)
            console.log("-->Stunden", duration);
        durationString = `${(duration - 10)} Stunden`;
    }
    else if (duration < 63) {
        if (DEBUG)
            console.log("-->Tage", duration);
        durationString = `${(duration - 33)} Tage`;
    }
    else {
        if (DEBUG)
            console.log("-->Monate", duration);
        durationString = `${duration - 62} Monate`;
    }
    if (output != null)
        output.textContent = durationString;
}
function appVoucherResultNewWindow(username, bearerToken, response, idString) {
    const myJSON = JSON.parse(response.target.response);
    if (DEBUG)
        console.log("-->appVoucherResultNewWindow", myJSON);
    let htmlNode = document.createElement('html');
    htmlNode.setAttribute('lang', 'de');
    let headNode = DomHelper.appendNode(htmlNode, 'head', []);
    DomHelper.appendNode(headNode, 'meta', [], [{ attr: 'charset', value: 'UTF-8' }]);
    DomHelper.appendNode(headNode, 'title', [], [], 'RuDi#Net Voucher drucken');
    DomHelper.appendNode(headNode, 'link', [], [{ attr: 'rel', value: 'stylesheet' }, { attr: 'href', value: 'css/main.css' }]);
    let bodyNode = DomHelper.appendNode(htmlNode, 'body', []);
    let mainNode = DomHelper.appendNode(bodyNode, 'main', [], [], "", 'voucherPrint');
    for (let voucher of myJSON.vouchers) {
        appVoucherPrint(mainNode, voucher, myJSON.network.ssid);
    }
    DomHelper.writeContent2NewTab(htmlNode);
}
function appVoucherResultCurrentElement(parentNode, username, bearerToken, response, wlanList, idString) {
    DomHelper.removeSpinner(parentNode);
    const myJSON = JSON.parse(response.target.response);
    if (DEBUG)
        console.log("-->appVoucherResultCurrentElement", myJSON);
    const voucherNode = DomHelper.appendNode(parentNode, 'section', [], [], '', 'voucher-show');
    DomHelper.appendNode(voucherNode, 'p', [], [], `${myJSON.network.ssid} | Gültig für ${Util.getDuration4Print(myJSON.vouchers[0].duration)}`);
    for (let voucher of myJSON.vouchers) {
        appVoucherShow(voucherNode, voucher, myJSON.network.ssid);
    }
    const appNode = DomHelper.getFirstParentWithClass(parentNode, 'rudi-app');
    if (appNode) {
        DomHelper.removeCloseSection(appNode);
        DomHelper.appendCloseSection(appNode, (event) => {
            appVoucherClearList(appNode, parentNode, username, bearerToken, event, wlanList, idString);
        });
    }
    DomHelper.addCopyToClipboardLink('.rudi-voucher-code');
}
function appVoucherClearList(appNode, voucherNode, username, bearerToken, event, wlanList, idString) {
    if (DEBUG)
        console.log("-->appVoucherClearList", event);
    closeVoucherApp(idString, appNode);
    DomHelper.removeCloseSection(appNode);
}
function appVoucherPrint(parentNode, voucher, ssid) {
    let articleNode = DomHelper.appendNode(parentNode, 'article', ['rudi-voucher']);
    let sectionNode = DomHelper.appendNode(articleNode, 'section', ['rudi-voucher-head'], []);
    DomHelper.appendNode(sectionNode, 'img', [], [{ attr: 'src', value: 'img/voucher_logo.png' },
        { attr: 'alt', value: 'Logo der Rummelsberger Diakonie' }]);
    DomHelper.appendNode(sectionNode, 'h1', [], [], 'WLAN Voucher');
    DomHelper.appendNode(articleNode, 'h2', [], [], ssid);
    DomHelper.appendNode(articleNode, 'div', ['rudi-voucher-duration'], [], `Gültig für ${Util.getDuration4Print(voucher.duration)}`);
    DomHelper.appendNode(articleNode, 'div', ['rudi-voucher-code'], [], (voucher.code).substring(0, 5) + "-" + (voucher.code).substring(5, 11));
}
function appVoucherShow(parentNode, voucher, ssid) {
    const node = DomHelper.appendNode(parentNode, 'article', ['rudi-voucher']);
    DomHelper.appendNode(node, 'div', ['rudi-voucher-code'], [], `${(voucher.code).substring(0, 5) + "-" + (voucher.code).substring(5, 11)}`);
}
function appVoucherToggle(event) {
    var _a;
    if (DEBUG)
        console.log("-->appVoucherToggle", event);
    let form = document.getElementById("rudi-wlan-form");
    if (form != null) {
        form.classList.remove("disabled");
        try {
            let app = DomHelper.getFirstParentWithClass(form, "rudi-app");
            if (DEBUG)
                console.log("found parent", app);
            app === null || app === void 0 ? void 0 : app.classList.add("full-width-interaction");
        }
        catch (e) {
            console.error(e);
        }
    }
    (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.classList.add("disabled");
}
function getUserVoucherInfo(username, bearerToken, callback) {
    let request = new XMLHttpRequest();
    request.open("GET", API_URL + "/users/voucher/" + username);
    request.setRequestHeader('Accept', 'application/json');
    request.setRequestHeader('Authorization', 'Bearer ' + bearerToken);
    request.addEventListener('load', callback);
    request.send();
}
function putVoucher(postData, bearerToken, callback) {
    let request = new XMLHttpRequest();
    request.open("PUT", API_URL + "/users/voucher");
    request.setRequestHeader('Content-Type', 'application/json');
    request.setRequestHeader('Authorization', 'Bearer ' + bearerToken);
    request.addEventListener('load', callback);
    let postBody = JSON.stringify(postData);
    request.send(postBody);
}
